import React, { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";
import { AlertTriangle, UserX } from "lucide-react";

export default function AlertasDesempenho() {
  const { user } = useAuth();
  const [docs, setDocs] = useState(null);

  useEffect(() => {
    if (!user?.empresa_id) { setDocs([]); return; }
    api.get(`/empresas/${user.empresa_id}/alertas-desempenho`)
      .then(r => setDocs(r.data))
      .catch(e => toast.error(formatApiError(e)));
  }, [user]);

  return (
    <div className="space-y-6" data-testid="alertas-desempenho-page">
      <div>
        <div className="text-[10px] font-bold uppercase tracking-[0.18em] text-aj-orange">Rede</div>
        <h1 className="font-display font-extrabold text-2xl sm:text-3xl text-aj-blue-deep mt-1">Alertas de Desempenho</h1>
        <p className="text-sm text-aj-text-muted mt-1 max-w-2xl">
          Montadores com score baixo (assistências em excesso, agenda descumprida ou avaliações ruins)
          que atenderam sua empresa nos últimos 30 dias. Considere avaliar a substituição.
        </p>
      </div>

      <div className="space-y-3">
        {docs?.length === 0 && (
          <div className="aj-card p-10 text-center text-aj-text-muted" data-testid="alertas-vazio">
            <AlertTriangle className="w-8 h-8 mx-auto mb-2 opacity-40" />
            Nenhum alerta de desempenho no momento. Sua rede está saudável.
          </div>
        )}
        {docs?.map((a) => (
          <div key={a.id} className="aj-card p-5 border-l-4 border-l-[#E60000]" data-testid={`alerta-card-${a.id}`}>
            <div className="flex items-start justify-between gap-3 flex-wrap">
              <div className="min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <UserX size={16} className="text-[#E60000]" />
                  <span className="font-display font-bold text-aj-blue-deep">{a.montador_nome || "Montador"}</span>
                  <span className="px-2 py-0.5 rounded-md text-[10px] font-bold uppercase bg-[#FEE2E2] text-[#B91C1C]">
                    Score {a.score}
                  </span>
                </div>
                <div className="text-xs text-aj-text-muted mt-1">
                  Semana {a.semana} · {new Date(a.criado_em).toLocaleString("pt-BR")}
                </div>
                <ul className="text-sm text-aj-text mt-2 list-disc list-inside">
                  {(a.motivos || []).map((m, i) => <li key={i}>{m}</li>)}
                </ul>
                {a.score_detalhes && (
                  <div className="flex gap-3 mt-3 text-xs text-aj-text-muted flex-wrap">
                    {a.score_detalhes.nota !== undefined && <span>Nota clientes: <b>{a.score_detalhes.nota}</b></span>}
                    {a.score_detalhes.faltas !== undefined && <span>Agenda: <b>{a.score_detalhes.faltas}</b></span>}
                    {a.score_detalhes.assistencias !== undefined && <span>Assistências: <b>{a.score_detalhes.assistencias}</b></span>}
                    {a.score_detalhes.sla !== undefined && <span>SLA: <b>{a.score_detalhes.sla}</b></span>}
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
